import React, { useState, useContext, useEffect } from "react";
import SidePanelElementCard from "./SidePanelElementCard";
import { SB3RuleContext } from "../Rules/SB3RuleContext";

type TSidePanelElementProps = {
    item: any;
    keyName: string;
    searchTerm: string;
    searchChoice: boolean
};


const SidePanelChildElement = ({ item, keyName, searchChoice, searchTerm }: TSidePanelElementProps) => {
    const { selectedObj } = useContext(SB3RuleContext);

    const [expanded, setExpanded] = useState(false);
    useEffect(() => {
        setExpanded(false)
    }, [selectedObj])

    useEffect(() => {
        searchTerm ? setExpanded(true) : setExpanded(false)
    }, [searchTerm])

    return (
        <>
            <SidePanelElementCard submodel={item.submodel} field={item.id} item={item} expanded={expanded} setExpanded={setExpanded} indent={4} />

            {
                expanded ?
                    item[keyName]?.map((choice: any, choiceIndex: number) => {
                        return (
                            <SidePanelElementCard submodel={item.submodel} field={item.id} key={choiceIndex} item={choice} expanded={expanded} setExpanded={setExpanded} indent={8} />
                        );
                    })
                    : null
            }
        </>
    );
};

export default SidePanelChildElement;
